import {
    Box,
    Card,
    CardContent,
    Typography,
    Link as MuiLink,
    Chip
} from '@mui/material';
import { GitHub, Article } from '@mui/icons-material';

export const FullStack = () => {
    return(
        <Box>
            <Typography variant="h4" component="h2" gutterBottom align="center" sx={{ mb: 4 }}>
                Full Stack
            </Typography>
            
            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 3 }}>
                <Box sx={{ flex: 1 }}>
                    <Card elevation={2}>
                        <CardContent>
                            <Typography variant="h5" component="h3" gutterBottom>
                                Docker for end to end (React + Mongo + Python)
                            </Typography>
                            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                                <iframe 
                                    width="100%" 
                                    height="200"
                                    src="https://www.youtube.com/embed/uYpBZV37L2U?list=PL01e4bnNRw-TLoPGoUR5fo2ETuj6qomNj"
                                    title="YouTube video player" 
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                />
                            </Box>
                            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', justifyContent: 'center' }}>
                                <Chip
                                    icon={<Article />}
                                    label="Medium Article"
                                    component={MuiLink}
                                    href="https://kmeeraj.medium.com/docker-for-end-to-end-react-mongo-python-e249bcfa6bc4"
                                    target="_blank"
                                    clickable
                                    color="primary"
                                />
                                <Chip
                                    icon={<GitHub />}
                                    label="GitHub"
                                    component={MuiLink}
                                    href="https://github.com/kmeeraj/reactpythonmongodocker/tree/master"
                                    target="_blank"
                                    clickable
                                    color="secondary"
                                />
                            </Box>
                        </CardContent>
                    </Card>
                </Box>
                
                <Box sx={{ flex: 1 }}>
                    <Card elevation={2}>
                        <CardContent>
                            <Typography variant="h5" component="h3" gutterBottom>
                                Redux Fundamentals of React in TypeScript
                            </Typography>
                            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                                <iframe 
                                    width="100%" 
                                    height="200"
                                    src="https://www.youtube.com/embed/r7WSM2l7FNM?list=PL01e4bnNRw-TLoPGoUR5fo2ETuj6qomNj"
                                    title="YouTube video player" 
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                />
                            </Box>
                            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', justifyContent: 'center' }}>
                                <Chip
                                    icon={<Article />}
                                    label="Medium Article"
                                    component={MuiLink}
                                    href="https://kmeeraj.medium.com/redux-fundamentals-of-react-in-typescript-c98642a35b6b"
                                    target="_blank"
                                    clickable
                                    color="primary"
                                />
                                <Chip
                                    icon={<GitHub />}
                                    label="GitHub"
                                    component={MuiLink}
                                    href="https://github.com/kmeeraj/reduxExample/tree/master"
                                    target="_blank"
                                    clickable
                                    color="secondary"
                                />
                            </Box>
                        </CardContent>
                    </Card>
                </Box>
            </Box>
        </Box>
    )
}